import React from "react";
import Styles from "./facilities_container.module.css";


export default function FacilitiesContainer({ facilities }) {


  const getFormattedFacilityName = (facility) => {
    return facility.toLowerCase().replace(/[ /]/g, '_');
  };

  const getFacilityIcon = (facility) => {
    const formattedFacilityName = getFormattedFacilityName(facility);

    if (formattedFacilityName.startsWith('game')) {
      return `../../../../icons/game.png`;
    } else { 
      const iconPath = `../../../../icons/${formattedFacilityName}.png`;
      return iconPath;
    }
  };

  return (
    <div className={Styles.chipsContainer}>
      {facilities.map((facility, index) => (
        <div key={index} className={Styles.chip}>
          <img src={getFacilityIcon(facility)} alt="" className={Styles.icon} />
          <span>{facility.toLowerCase()}</span>
        </div>
      ))}
    </div>
  );
}
